module.exports = __webpack_public_path__ + "img/back.89e98a32.gif";